import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2f9c4d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "empresa",
  class: "main-sobre"
}
const _hoisted_2 = { class: "container-sobre" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"coluna-imagem\" data-v-e2f9c4d8><img src=\"/conteudo/silos.jpg\" alt=\"Instalação industrial em silos de armazenagem\" class=\"imagem-sobre\" loading=\"lazy\" data-v-e2f9c4d8><div class=\"cartao-obras\" data-v-e2f9c4d8><span class=\"numero-obras\" data-v-e2f9c4d8> +500 </span><span class=\"legenda-obras\" data-v-e2f9c4d8> obras entregues </span></div></div>", 1)
const _hoisted_4 = { class: "coluna-texto" }
const _hoisted_5 = { class: "rotulo-secao" }
const _hoisted_6 = { class: "titulo-secao" }
const _hoisted_7 = { class: "paragrafo" }
const _hoisted_8 = { class: "paragrafo" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"grade-areas\" data-v-e2f9c4d8><div class=\"item-area\" data-v-e2f9c4d8><span class=\"ponto-area\" data-v-e2f9c4d8></span> Usinas fotovoltaicas </div><div class=\"item-area\" data-v-e2f9c4d8><span class=\"ponto-area\" data-v-e2f9c4d8></span> Automação industrial </div><div class=\"item-area\" data-v-e2f9c4d8><span class=\"ponto-area\" data-v-e2f9c4d8></span> Data centers </div><div class=\"item-area\" data-v-e2f9c4d8><span class=\"ponto-area\" data-v-e2f9c4d8></span> Telecomunicações e dados </div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.TituloPrimeiroParagrafo), 1),
        _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.Titulo), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.TextoPrimerioPagrafo), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.TextoSegundoPagrafo), 1),
        _hoisted_9
      ])
    ])
  ]))
}